import { Button } from '..';
import {
	Drawer,
	Hidden,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
} from '@material-ui/core';
import { ExitToApp as ExitIcon } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { type Route } from 'src/models';
import { privateRoutes } from 'src/modules/Private/routes';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import useStyles from './Navbar.styles';

import { type RootState } from 'src/store';
import authActions from 'src/store/Auth/actions';

interface Props {
	openMobile: boolean;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	onMobileClose: any;
}

function Navbar({ onMobileClose, openMobile }: Props) {
	const classes = useStyles();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const auth = useSelector((state: RootState) => state.auth);
	const logout = () => dispatch(authActions.logout());

	useEffect(() => {
		if (openMobile && onMobileClose) {
			onMobileClose();
		}
	}, [location.pathname]);

	const content = (
		<div className={classes.drawerContainer}>
			<List className={classes.list}>
				{privateRoutes.map((route: Route, index: number) => {
					if (
						route.isMenuItem &&
						route.rights.includes(auth.data.type)
					) {
						const Icon = route.icon;

						return (
							<ListItem
								button
								className={clsx({
									[classes.selected]:
										window.location.pathname.includes(
											route.path,
										),
								})}
								component={Link}
								key={index}
								to={route.path}
							>
								<ListItemIcon>
									{' '}
									<Icon />{' '}
								</ListItemIcon>

								<ListItemText primary={route.title} />
							</ListItem>
						);
					}
				})}
			</List>

			<ListItem button onClick={logout} style={{ cursor: 'pointer' }}>
				<ListItemIcon>
					{' '}
					<ExitIcon />{' '}
				</ListItemIcon>

				<ListItemText primary={'Salir'} />
			</ListItem>
		</div>
	);

	return (
		<>
			<Hidden lgUp>
				<Drawer
					className={classes.drawer}
					classes={{
						paper: classes.drawerPaper,
					}}
					onClose={onMobileClose}
					open={openMobile}
					variant={'temporary'}
				>
					{content}
				</Drawer>
			</Hidden>

			<Hidden mdDown>
				<Drawer
					className={classes.drawer}
					classes={{
						paper: classes.drawerPaper,
					}}
					open
					variant={'persistent'}
				>
					{content}
				</Drawer>
			</Hidden>
		</>
	);
}

export default Navbar;
